import React from 'react';
import { useStore, productSubcat } from '../context/StoreContext';
import { Icons } from './Icons';
import SmartImage from './SmartImage';
import { contrastText } from '../utils/colorNames';
import './CartDrawer.css';

export default function CartDrawer() {
  const {
    cart, cartOpen, setCartOpen, cartTotal,
    changeQty, removeItem, checkoutWA, Rs, currentUser,
  } = useStore();

  return (
    <>
      <div
        className={`cart-overlay${cartOpen ? ' open' : ''}`}
        onClick={() => setCartOpen(false)}
      />

      <aside
        className={`cart-drawer${cartOpen ? ' open' : ''}`}
        aria-hidden={!cartOpen}
        aria-label="Shopping cart"
      >
        <div className="cart-header">
          <h3>YOUR CART</h3>
          <button className="cart-close-btn" onClick={() => setCartOpen(false)} aria-label="Close cart">
            {Icons.close()}
          </button>
        </div>

        <div className="cart-body">
          {cart.length === 0 ? (
            <div className="cart-empty">
              {Icons.cart(44)}
              <p>Your cart is empty</p>
              <span className="cart-empty__hint">Pieces you add will show up here.</span>
            </div>
          ) : (
            cart.map((item) => {
              /* Lines are keyed by product + colour, so the same ring in
                 two colours stays as two independent rows. */
              const ref = item.key || item.id;
              const sub = productSubcat(item);

              return (
                <div key={ref} className="cart-item">
                  <SmartImage
                    src={item.img}
                    alt={item.name}
                    className="cart-item-img"
                    sizes="72px"
                    widths={[120, 200]}
                    fallback={<span className="cart-item-img__icon">{Icons.diamond(22)}</span>}
                  />

                  <div className="cart-item-info">
                    <div className="cart-item-name">{item.name}</div>

                    <div className="cart-item-cat">
                      {item.cat}{sub && ` · ${sub}`}
                    </div>

                    {/* Colour travels all the way to the WhatsApp order,
                        so show the shopper exactly what will be sent. */}
                    {item.colorName && (
                      <div className="cart-item-color">
                        <span
                          className="cart-item-color__dot"
                          style={{
                            background: item.colorHex || '#ccc',
                            color: contrastText(item.colorHex || '#cccccc'),
                          }}
                        />
                        <span className="cart-item-color__name">{item.colorName}</span>
                        {item.colorHex && <code>{item.colorHex}</code>}
                      </div>
                    )}

                    {item.size && (
                      <div className="cart-item-size">Size: {item.size}</div>
                    )}

                    <div className="cart-item-qty">
                      <button
                        className="qty-btn"
                        onClick={() => changeQty(ref, -1)}
                        aria-label={`Reduce quantity of ${item.name}`}
                      >
                        {Icons.minus()}
                      </button>
                      <span className="qty-num">{item.qty}</span>
                      <button
                        className="qty-btn"
                        onClick={() => changeQty(ref, 1)}
                        aria-label={`Increase quantity of ${item.name}`}
                      >
                        {Icons.plus()}
                      </button>
                    </div>
                  </div>

                  <div className="cart-item-right">
                    <button
                      className="cart-item-del"
                      onClick={() => removeItem(ref)}
                      aria-label={`Remove ${item.name}`}
                    >
                      {Icons.close(15)}
                    </button>
                    <div className="cart-item-price">{Rs(item.price * item.qty)}</div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {cart.length > 0 && (
          <div className="cart-footer">
            <div className="cart-total-row">
              <span className="cart-total-label">Total</span>
              <span className="cart-total-value">{Rs(cartTotal)}</span>
            </div>

            <button className="btn-checkout" onClick={checkoutWA}>
              {currentUser
                ? <>{Icons.whatsapp(16)} Checkout via WhatsApp</>
                : <>{Icons.lock(16)} Log in to checkout</>}
            </button>

            <button className="btn-continue" onClick={() => setCartOpen(false)}>
              Continue shopping
            </button>
          </div>
        )}
      </aside>
    </>
  );
}
